/* =========================================================
   Adapter fiche produit KOM / TROPHÉE DE SEGMENT (Shopify).
   - Charge le profil du col via son data-map (SP.mapDataUrl)
   - Palette (8) + tous les champs perso + taille/cadre/prix/panier
   ========================================================= */
(function () {
  const SP = window.SPORTSNDECO_KOM;
  if (!SP) return;

  const SIZE_LABEL  = { '30x40':'30 × 40 cm', '50x70':'50 × 70 cm', '70x100':'70 × 100 cm' };
  const FRAME_LABEL = { none:'Sans cadre', black:'Cadre noir', natural:'Cadre bois naturel' };
  const SIZES  = [{id:'30x40',label:'30 × 40 cm'},{id:'50x70',label:'50 × 70 cm'},{id:'70x100',label:'70 × 100 cm'}];
  const SN_DIG = window.SPORTSNDECO_DIGITAL || null;
  if (SN_DIG && SN_DIG.variantId) SIZES.push({ id: 'digital', label: 'Fichier numérique HD' });
  function snDigitalUi() {
    var dig = state.size === 'digital';
    var fw = document.getElementById('frameOptions');
    if (fw) {
      var note = document.getElementById('snDigitalFrameNote');
      if (dig) {
        fw.style.display = 'none';
        if (!note) {
          note = document.createElement('p');
          note.id = 'snDigitalFrameNote';
          note.style.cssText = "font:400 13px/1.5 'Inter',sans-serif;color:#5b6b82;margin:4px 0 0;";
          note.textContent = "Fichier num\u00e9rique : pas de cadre \u2014 vous recevez le PDF haute d\u00e9finition par e-mail, imprimable jusqu'en 70\u00d7100 cm.";
          fw.parentNode.insertBefore(note, fw.nextSibling);
        } else note.hidden = false;
      } else { fw.style.display = ''; if (note) note.hidden = true; }
    }
    var dl = document.querySelector('[data-sn-delivery] [data-sn-delivery-main], [data-sn-delivery] .sn-delivery__main');
    if (dl) {
      if (dig) { if (!dl.dataset.print) dl.dataset.print = dl.innerHTML; dl.innerHTML = 'Fichier HD envoy\u00e9 par e-mail <strong>apr\u00e8s paiement</strong>'; }
      else if (dl.dataset.print) { dl.innerHTML = dl.dataset.print; delete dl.dataset.print; }
    }
    ['digital','replique','carte'].forEach(function(k){ var up=document.querySelector('.sn-upsell[data-key="'+k+'"]'); if(up) up.style.display = dig ? 'none' : ''; });
  }
  const FRAMES = [{id:'none',label:'Sans cadre'},{id:'black',label:'Cadre noir'},{id:'natural',label:'Cadre bois naturel'}];

  const state = { palette:'nuit', size:'50x70', frame:'none', data:null, ride:null };
  const OVERPASS = ['https://overpass-api.de/api/interpreter','https://overpass.kumi.systems/api/interpreter'];
  const $ = id => document.getElementById(id);
  const money = c => (c/100).toFixed(2).replace('.',',') + ' €';
  function variant(s,f){ if (s === 'digital' && SN_DIG) return { id: SN_DIG.variantId, price: SN_DIG.priceCents, options: ['Fichier num\u00e9rique HD'], available: true, digital: true }; return SP.variants.find(v => v.options.includes(SIZE_LABEL[s]) && v.options.includes(FRAME_LABEL[f])); }
  function upsellsCents(){ return (typeof window.snUpsellsTotalCents==='function') ? window.snUpsellsTotalCents() : 0; }
  function refreshPrice(){
    const v = variant(state.size, state.frame), base = v ? v.price : 0, total = base + upsellsCents();
    const pe=$('productPrice'); if(pe) pe.textContent = v ? money(base) : '—';
    ['cartPrice','snStickyPrice'].forEach(id => { const e=$(id); if(e) e.textContent = v ? money(total) : '—'; }); snDigitalUi(); }
  window.snRefreshPrice = refreshPrice;

  const val = id => { const e=$(id); return e ? e.value : ''; };
  function opts(){
    return { palette:state.palette,
      athlete:val('komAthlete'), time:val('komTime'), rank:val('komRank')||1, attempts:val('komAttempts'),
      power:val('komPower'), speed:val('komSpeed'), hr:val('komHr'), date:val('komDate'),
      kicker:val('komKicker'),
      duo: ($('komDuo') && $('komDuo').checked) ? { n1:val('komD1Name'), t1:val('komD1Time'), n2:val('komD2Name'), t2:val('komD2Time') } : undefined };
  }
  function buildData(){
    const d = Object.assign({}, state.data);
    const seg = val('komSegment'); if (seg && seg.trim()) d.segment = seg.trim();
    if (state.ride) {
      d.mapCoords = state.ride.coords; d.mapRoads = state.ride.roads || [];
      if (state.ride.km) d.distance = String(state.ride.km).replace('.',',') + ' km';
      if (state.ride.dplus != null) d.dplus = state.ride.dplus + ' m';
      if (state.ride.pct != null) d.pente = String(state.ride.pct).replace('.',',') + ' %';
    }
    return d;
  }
  function draw(){
    if (!state.data || typeof SNKom==='undefined') return;
    const svg = SNKom.render(buildData(), opts());
    const el = $('komPreview'); if (el) el.innerHTML = svg;
    const pf = $('posterFrame'); if (pf) pf.dataset.frame = state.frame;
    document.querySelectorAll('.sn-frame-thumb .poster').forEach(x => { x.innerHTML = svg; });
  }

  /* ---- import GPX/TCX/FIT du segment → carte ---- */
  async function fetchRoads(bbox){
    const { S, W, N, E } = bbox;
    const q = `[out:json][timeout:30];(way["highway"](${S},${W},${N},${E}););out geom;`;
    for (const ep of OVERPASS){ try {
      const r = await fetch(ep, { method:'POST', body:'data='+encodeURIComponent(q) });
      const t = await r.text(); if (t.trim().startsWith('{')){ const els=JSON.parse(t).elements; if(els&&els.length) return els; }
    } catch(e){} }
    return [];
  }
  function bboxOf(coords){ let S=90,W=180,N=-90,E=-180; for(const [lo,la] of coords){ if(la<S)S=la; if(la>N)N=la; if(lo<W)W=lo; if(lo>E)E=lo; } const px=(E-W)*0.1||0.005, py=(N-S)*0.1||0.005; return { S:S-py, W:W-px, N:N+py, E:E+px }; }
  function maxEle(s){ let m=-Infinity; for(const x of s) if(typeof x.ele==='number'&&x.ele>m)m=x.ele; return isFinite(m)?Math.round(m):null; }

  async function handleFile(file){
    const ext=(file.name.split('.').pop()||'').toLowerCase(); let activity;
    try {
      if (ext==='gpx' && typeof parseGPX==='function') activity=parseGPX(await file.text());
      else if (ext==='tcx' && typeof parseTCX==='function') activity=parseTCX(await file.text());
      else if (ext==='fit' && typeof parseFIT==='function') activity=await parseFIT(await file.arrayBuffer());
      else { alert('Format non supporté (GPX, TCX ou FIT).'); return; }
    } catch(e){ alert('Erreur de lecture : '+e.message); return; }
    const coords=(activity.samples||[]).filter(s=>typeof s.lat==='number'&&typeof s.lon==='number').map(s=>[s.lon,s.lat]);
    if (coords.length<2){ alert("Ce fichier ne contient pas de tracé GPS."); return; }
    const stats=(typeof computeStats==='function')?computeStats(activity):{};
    const km=stats.distanceM?+(stats.distanceM/1000).toFixed(1):0, dplus=stats.elevGainM?Math.round(stats.elevGainM):null;
    const pct=(stats.distanceM&&stats.elevGainM)?+((stats.elevGainM/stats.distanceM)*100).toFixed(1):null;
    state.ride={ coords, roads:[], km, dplus, pct };
    if ($('komSegment') && !$('komSegment').value.trim() && activity.name) $('komSegment').value=activity.name.slice(0,26);
    const dz=$('komDropzone'); if(dz){ dz.querySelector('.dz-title').textContent='✓ '+file.name; dz.querySelector('.dz-sub').textContent=km+' km · carte en cours…'; }
    const rst=$('komResetRide'); if(rst) rst.hidden=false;
    draw();
    try { const roads=await fetchRoads(bboxOf(coords)); state.ride.roads=roads; draw(); if(dz)dz.querySelector('.dz-sub').textContent=km+' km · '+roads.length+' routes'; }
    catch(e){ if(dz)dz.querySelector('.dz-sub').textContent=km+' km (fond simplifié)'; }
  }
  function resetRide(){ state.ride=null; const dz=$('komDropzone'); if(dz){dz.querySelector('.dz-title').textContent='Déposez le GPX de votre segment';dz.querySelector('.dz-sub').textContent='GPX · TCX · FIT — affiche la carte';} const rst=$('komResetRide'); if(rst)rst.hidden=true; draw(); }
  function bindImport(){
    const dz=$('komDropzone'), input=$('komFileInput'), browse=$('komBrowseBtn'), rst=$('komResetRide');
    if (browse&&input) browse.addEventListener('click',()=>input.click());
    if (input) input.addEventListener('change',e=>{ if(e.target.files[0]) handleFile(e.target.files[0]); });
    if (dz){ ['dragenter','dragover'].forEach(ev=>dz.addEventListener(ev,e=>{e.preventDefault();dz.classList.add('dragover');}));
      ['dragleave','drop'].forEach(ev=>dz.addEventListener(ev,e=>{e.preventDefault();dz.classList.remove('dragover');}));
      dz.addEventListener('drop',e=>{ if(e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]); }); }
    if (rst) rst.addEventListener('click',resetRide);
  }
  function syncFrameThumbs(){ document.querySelectorAll('.sn-frame-thumb').forEach(t => t.classList.toggle('active', t.dataset.frame===state.frame)); }

  function renderPalettes(){
    const wrap = $('komPalettes'); if (!wrap || typeof SNKom==='undefined') return;
    wrap.innerHTML = '';
    Object.entries(SNKom.PALETTES).forEach(([id,p]) => {
      const b = document.createElement('button');
      b.type='button'; b.className='sn-col-pal'+(id===state.palette?' active':''); b.title=p.label;
      b.innerHTML = `<span style="background:${p.bg}"></span><em style="background:${p.accent}"></em>`;
      b.addEventListener('click', ()=>{ state.palette=id; wrap.querySelectorAll('.sn-col-pal').forEach(x=>x.classList.toggle('active',x===b)); draw(); });
      wrap.appendChild(b);
    });
  }
  function renderSizes(){
    const w=$('sizeOptions'); if(!w) return;
    w.innerHTML = SIZES.map(s=>{const v=variant(s.id,state.frame);
      return `<button class="size-opt ${s.id===state.size?'active':''}" data-size="${s.id}" type="button"><span class="size-label">${s.label}</span><span class="size-price">${v?money(v.price):'—'}</span></button>`;
    }).join('');
    w.querySelectorAll('.size-opt').forEach(b=>b.addEventListener('click',()=>{state.size=b.dataset.size;renderSizes();renderFrames();refreshPrice();}));
  }
  function renderFrames(){
    const w=$('frameOptions'); if(!w) return;
    w.innerHTML = FRAMES.map(f=>{const v=variant(state.size,f.id);
      return `<button class="frame-opt ${f.id===state.frame?'active':''}" data-frame="${f.id}" type="button"><span class="frame-swatch frame-swatch-${f.id}"></span><span class="frame-label">${f.label}</span><span class="frame-price">${v?money(v.price):'—'}</span></button>`;
    }).join('');
    w.querySelectorAll('.frame-opt').forEach(b=>b.addEventListener('click',()=>{state.frame=b.dataset.frame;renderSizes();renderFrames();refreshPrice();syncFrameThumbs();draw();}));
  }
  function bindMockups(){
    document.querySelectorAll('.sn-frame-thumb').forEach(t=>t.addEventListener('click',()=>{ state.frame=t.dataset.frame; renderSizes(); renderFrames(); refreshPrice(); syncFrameThumbs(); draw(); }));
    syncFrameThumbs();
  }

  function bindCart(){
    const btn=$('addToCartBtn'); if(!btn) return;
    const buy=$('buyNowBtn'), sticky=$('snStickyAddBtn');
    if (buy) buy.addEventListener('click',e=>{e.preventDefault();window.__snBuyNow=true;btn.click();});
    if (sticky) sticky.addEventListener('click',e=>{e.preventDefault();btn.click();});
    btn.addEventListener('click', async ()=>{
      const v=variant(state.size,state.frame); if(!v){alert('Variante introuvable');return;}
      const o=opts();
      const props={ 'Palette': (SNKom.PALETTES[state.palette]||{}).label || state.palette };
      const map={athlete:'Athlète',time:'Temps',rank:'Rang',attempts:'Tentatives',power:'Puissance',speed:'Vitesse',hr:'FC',date:'Date',kicker:'Titre'};
      Object.keys(map).forEach(k=>{ const vv=(o[k]||'').toString().trim(); if(vv && !(k==='rank'&&vv==='1')) props[map[k]]=vv; });
      const segOv=(val('komSegment')||'').trim(); if(segOv) props['Segment']=segOv;
      const duo = o.duo && [o.duo.n1,o.duo.t1,o.duo.n2,o.duo.t2].some(x=>String(x||'').trim()) ? o.duo : null;
      if (duo){ const lbl=[[duo.n1,duo.t1].filter(Boolean).join(' '),[duo.n2,duo.t2].filter(Boolean).join(' ')].filter(Boolean).join(' & '); if(lbl) props['Duo']=lbl; }
      const payload={ kom:SP.presetId, palette:state.palette, ...o, segment:segOv||undefined, size:state.size, frame:state.frame,
        mapUrl:SP.mapDataUrl };  // → re-render serveur (worker Gelato) pour les presets
      if (state.ride){ const c=state.ride.coords, step=Math.max(1,Math.ceil(c.length/120)); const ds=c.filter((_,i)=>i%step===0); if(ds[ds.length-1]!==c[c.length-1])ds.push(c[c.length-1]);
        payload.ride={ km:state.ride.km, dplus:state.ride.dplus, coords:ds.map(pt=>[+pt[0].toFixed(5),+pt[1].toFixed(5)]) };
        props['Tracé']='Segment GPX importé ('+state.ride.km+' km)';
        // Segment importé : upload de l'aperçu exact (le worker ne refait pas Overpass).
        if (window.snPrintUpload) {
          const up = await window.snPrintUpload.fromSvg(SNKom.render(buildData(), o),
            { fontCssUrls: [window.snPrintUpload.FONTS.sora], size: state.size });
          if (up) { props['_print_url']=up.url; props['_print_bg']=(SNKom.PALETTES[state.palette]||{}).bg||'#ffffff'; }
          else props['_print_error'] = String(window.snPrintUpload.lastError() || 'inconnu');
        } }
      props['_perso']=JSON.stringify(payload);
      if (state.size === 'digital') { props['Format'] = 'Fichier num\u00e9rique HD (PDF par e-mail)'; var h1 = document.querySelector('h1.product-title, h1'); if (h1) props['Mod\u00e8le'] = h1.textContent.trim(); }
      const items=[{ id:v.id, quantity:1, properties:props }];
      if (typeof window.snCollectUpsells==='function') { try { items.push(...window.snCollectUpsells()); } catch(e){} }
      const sp=btn.querySelector('span'); const old=sp?sp.textContent:''; btn.disabled=true; if(sp)sp.textContent='Ajout…';
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if(!r.ok){const e=await r.json().catch(()=>({}));throw new Error(e.description||e.message||('Erreur '+r.status));}
        if(window.__snBuyNow){window.__snBuyNow=false;window.location.href='/checkout';return;}
        document.dispatchEvent(new CustomEvent('sn:cart-added'));
      }catch(e){alert("Erreur d'ajout au panier : "+e.message);}
      finally{setTimeout(()=>{if(sp)sp.textContent=old;btn.disabled=false;},600);}
    });
  }
  function bindSticky(){
    const sticky=$('snStickyCta'), cart=$('addToCartBtn'); if(!sticky||!cart) return;
    const mob=()=>window.matchMedia('(max-width:900px)').matches;
    function up(){ if(!mob()){sticky.classList.remove('is-visible');return;}
      const r=cart.getBoundingClientRect(); const near=(innerHeight+scrollY)>(document.body.scrollHeight-200);
      sticky.classList.toggle('is-visible', r.bottom<60 && !near); }
    addEventListener('scroll',up,{passive:true}); addEventListener('resize',up); up();
  }

  document.addEventListener('DOMContentLoaded', async () => {
    renderPalettes(); renderSizes(); renderFrames(); refreshPrice(); bindCart(); bindSticky(); bindMockups(); bindImport();
    ['komAthlete','komTime','komRank','komAttempts','komPower','komSpeed','komHr','komDate','komKicker','komSegment'].forEach(id=>{ const e=$(id); if(e) e.addEventListener('input',draw); });
    ['komD1Name','komD1Time','komD2Name','komD2Time'].forEach(id=>{ const e=$(id); if(e) e.addEventListener('input',draw); });
    const kdt=$('komDuo'); if(kdt) kdt.addEventListener('change',()=>{ const df=$('komDuoFields'); if(df) df.hidden=!kdt.checked; const sb=$('komSoloPerso'); if(sb) sb.hidden=kdt.checked; draw(); });
    try {
      const r = await fetch(SP.mapDataUrl); const md = await r.json();
      const co = md.col || {}, pr = md.profile;
      const dplus = pr ? (pr.eMax - pr.eMin) : co.dplus;
      state.data = {
        segment: co.name || SP.title, location: [co.side, co.region].filter(Boolean).join(' · '),
        distance: (co.km!=null?String(co.km).replace('.',','):'') + ' km',
        dplus: (dplus!=null?dplus:'') + ' m',
        pente: (co.pct!=null?String(co.pct).replace('.',','):(pr?(dplus/(pr.km*1000)*100).toFixed(1).replace('.',','):'')) + ' %',
        profile: pr || { pts:[[0,0],[1,0]], km:1, eMin:0, eMax:1 },
      };
      draw();
    } catch(e){ console.error('[kom] data-map non chargé', e); }
  });
})();
